import { ClinicLocation, SearchType } from '@nrwl/rx-models';
import {
  RxReactiveFormCompositeComponent,
  RxTextCompositeComponent,
  RxVideoCompositeComponent,
} from '@nrwl/rx-forms';

import { DialogsConfigService } from '../dialogs-config.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ClinicLocationDialogConfigService extends DialogsConfigService {
  constructor() {
    super();
  }

  public confirmClone() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Clone the Location?',
        tip: 'Existing location details will be copied to the new location',
        buttons: this.SubmitDismissButtons('Yes', 'No'),
      },
    };
  }

  public confirmDelete(location) {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: `Are you sure you want to delete ${location.name}?`,
        tip: 'You are about to delete a clinic location. These changes cannot be reversed. Please confirm below',
        buttons: this.SubmitDismissButtons('Confirm', 'Cancel'),
      },
    };
  }

  public helpCenter() {
    return {
      component: RxVideoCompositeComponent,
      payload: {
        title: 'Help Center',
        buttons: this.DismissButton(),
      },
    };
  }

  public permissionsInfo() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Alert',
        tip:
          '' +
          'Employees with Administrator permission status have access to these areas.' +
          ' If you are seeing this message and feel you should have access,' +
          ' please contact with your administator and request change in permissions.',
        tipClose: false,
        buttons: this.SubmitButton('I understand'),
      },
    };
  }

  public auditRestrictionInfo() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Alert',
        tip:
          '' +
          'Employees with Super Administrator permission status have access to these areas.' +
          ' If you are seeing this message and feel you should have access,' +
          ' please contact with your administator and request change in permissions.', // <a>See Permission structure</a>
        tipClose: false,
        buttons: this.SubmitButton('I understand'),
      },
    };
  }

  public versionInfo() {
    return {
      component: RxTextCompositeComponent,
      panelClass: 'version-info',
      payload: {
        tipClose: false,
        buttons: this.SubmitButton('Update Version'),
      },
    };
  }

  public confirmResetChanges() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Confirm changes',
        tip: 'Unsaved changes may be lost',
        buttons: this.SubmitDismissButtons('Proceed', 'Cancel'),
      },
    };
  }

  public confirmLeavingPage() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Confirm Navigation',
        tip: 'You have unsaved changes. Are you sure you want to leave this page?',
        buttons: this.SubmitDismissButtons('Leave this Page', 'Stay on this Page'),
      },
    };
  }

  public createLocation() {
    return {
      component: RxReactiveFormCompositeComponent,
      payload: {
        title: 'Add Location',
        tip: 'Please complete the required fields below to add a new location',
        buttons: this.SubmitDismissButtons(),
      },
    };
  }

  public locationLimitInfo(limit: number) {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Location Limit',
        tip:
          `Your RxPhoto App account is registered with ${limit} location(s). ` +
          'If you would like to upgrade your account please contact sales@rxphoto.com',
        buttons: this.SubmitButton('I understand'),
      },
    };
  }

  public administratorRestriction() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Warning',
        tip: 'You must have Super Administrator permission status to access these areas. If you are seeing this message and feel you should have access, please contact with your administrator and request change in permissions. ',
        buttons: this.SubmitButton('OK'),
      },
    };
  }
}
